import { render } from "./DateDisplay.vue?vue&type=template&id=7fe7f5ae&scoped=true"
import script from "./DateDisplay.vue?vue&type=script&lang=js"
export * from "./DateDisplay.vue?vue&type=script&lang=js"

import "./DateDisplay.vue?vue&type=style&index=0&id=7fe7f5ae&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fe7f5ae"]])

export default __exports__